import { AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { SwiperContainer } from 'swiper/element';
import { first } from 'rxjs/operators';
import * as moment from 'moment';
import _ from 'lodash';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-food-list',
	templateUrl: './food-list.page.html',
	styleUrls: ['./food-list.page.scss'],
})
export class FoodListPage implements OnInit, AfterViewInit {
	@ViewChildren('animatedList', { read: ElementRef }) animatedListRef: QueryList<ElementRef>;
	@ViewChildren('animatedSegment', { read: ElementRef }) animatedSegmentRef: QueryList<ElementRef>;
	@ViewChild('dateSwiper', { static: false }) dateSwiper!: ElementRef<SwiperContainer>;
	@Input() myActiveSubscriptions;
	settings: any = {};
	loader: boolean = true;
	dummyImg = "../../assets/dummy.png";
	slideOption = {
		slidesPerView: 7,
		speed: 400,
		initialSlide: 0,
	}
	menuData: any;
	menuList: any = []; globalMenuList = [];
	menuType: string; defaultMenu: string;
	mainMenu: any = [];

	currentMealsCount: number = 0;
	currentSnacksCount: number = 0;

	protiens: any = 0;
	calories: any = 0;
	carbs: any = 0;
	fats: any = 0;
	bookMealData: any = [];
	isBookMenuFooterVisible: boolean = false;

	selectedDate: string = moment().format('YYYY/MM/DD');
	calendarArray = [];
	today = moment().format("YYYY-MM-DD");
	currentDate = moment().format('YYYY-MM-DD');
	selectedIndex: number = 0;
	displayDate = moment().format('YYYY-MM-DD');
	storeData: any;
	is_date_show: any;
	weekDayArray = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
	weekDayOff: number; weekDay: string;
	segmentMenu: any[] = [];
	constructor(
		public router: Router,
		private ngZone: NgZone,
		private toastCtrl: ToastController,
		private configService: ConfigService,
		private apiService: ApiService,
		private translate: TranslateService
	) {
		console.log(this.router.url);
	}
	async ngOnInit() {
		this.storeData = await this.configService.getStorage('appPayload');
		this.is_date_show = Number(this.storeData.is_menu_date_wise);
		const dayOff = this.storeData?.configurations?.settings?.week_day_off ? Number(this.storeData?.configurations?.settings?.week_day_off) : 5;
		//console.log(dayOff);
		//const dayOff = 5;
		this.weekDayOff = Number(dayOff - 1);
		this.weekDay = this.weekDayArray[this.weekDayOff];
		const daysAfter = this.storeData?.configurations?.settings?.menu_selection_before ? Number(this.storeData?.configurations?.settings?.menu_selection_before) : 0;
		this.selectedDate = moment(this.selectedDate).add(daysAfter, 'days').format('YYYY-MM-DD');
		if (moment(this.selectedDate).format('ddd') == this.weekDay) {
			//console.log(this.weekDay);
			this.selectedDate = moment(this.selectedDate).add(Number(1), 'days').format('YYYY-MM-DD');
		}
		this.displayDate = this.selectedDate;

		const redirectDate = await this.configService.getStorage('date');
		console.log(redirectDate);
		this.selectedDate = redirectDate ? moment(redirectDate).format('YYYY-MM-DD') : this.selectedDate;
		this.displayDate = this.selectedDate;
		this.configService.setStorage('date', null);

		this.menuCaller(this.selectedDate);
		this.selectedIndex = Number(moment(this.displayDate).format('DD'));
		console.log(this.storeData);
		console.log(this.is_date_show);
		this.calendarArray = this.getDaysArrayByMonth(this.displayDate);
		this.configService.getAppSettings()
			.then((settingData: any) => {
				this.settings = JSON.parse(settingData);
				//console.log(this.settings);
				this.translate.setDefaultLang(this.settings.appLanguage);
				this.translate.use(this.settings.appLanguage);
			}
			);
	}
	ngAfterViewInit() {
		setTimeout(() => {
			if (this.is_date_show == 1) {
				this.dateSwiper?.nativeElement?.swiper?.slideTo(this.selectedIndex - 1, 1000);
			}
			this.configService.setStorage('date', null);
		}, 1000);
		this.displayDate = this.selectedDate;
	}
	resetData = () => {
		this.protiens = 0;
		this.calories = 0;
		this.carbs = 0;
		this.fats = 0;
	}
	resetMenu = () => {
		this.mainMenu = [];
		this.menuList = [];
		this.defaultMenu = null;
	}
	dateSegmentChange = (event: any) => {
		this.resetData(); this.resetMenu();
		let givenDate = event.detail.value;
		console.log(givenDate);
		this.selectedDate = moment(givenDate).format('YYYY/MM/DD');
		console.log(this.selectedDate);
		this.menuCaller(this.selectedDate);

	}
	menuCaller = (date: string) => {
		console.log(date);
		this.loader = true;
		this.apiService
			.get(this.is_date_show == 1 ? endpoints.menuSubscriptions + '?date=' + moment(date).format('YYYY-MM-DD') : endpoints.menuSubscriptions)
			.pipe(first())
			.subscribe(result => {
				console.log(result);
				this.loader = false;
				if (result.success && result.data?.menu_builders.length > 0) {
					this.menuList = result.data.menu_builders;
					this.menuList.map((menuData) => {
						this.segmentMenu.push(menuData.type_name);
					});
					console.log(this.mainMenu);
					this.defaultMenu = this.menuList[0].type_name;
					this.mainMenu = this.menuList[0].type_data;
					this.displayDate = this.selectedDate;
				}
			}, err => {
				this.loader = false;
			});
	}
	nextFoodType = () => {
		const index = this.segmentMenu.indexOf(this.defaultMenu) > -1 ? Number(this.segmentMenu.indexOf(this.defaultMenu) + 1) : -1;
		console.log(index, this.segmentMenu.length);
		if (index > -1 && index < this.segmentMenu.length) {
			this.defaultMenu = this.segmentMenu[index];
		}
	}
	selectFoodType = (event: any) => {
		this.loader = true;
		console.log(this.menuList);
		this.defaultMenu = event.target.value;
		this.menuList.map((menu) => {
			if (menu.type_name === this.defaultMenu) {
				this.mainMenu = menu.type_data;
			}
		});
		this.loader = false;
	}
	getActiveIndex = (index: number) => {
		return index == this.selectedIndex;
	}
	prevDate = () => {
		//if (moment(this.displayDate).isAfter(moment(this.today))) {}
		this.resetData(); this.resetMenu();
		let startMonth = moment(this.displayDate).format('MM');
		this.displayDate = moment(this.displayDate).subtract(1, 'days').format('YYYY-MM-DD');
		this.selectedIndex = Number(moment(this.displayDate).format('DD'));
		//console.log(this.selectedIndex);
		setTimeout(() => {
			this.dateSwiper?.nativeElement?.swiper?.slideTo(this.selectedIndex - 1, 1000);
		}, 1000);
		let endMonth = moment(this.displayDate).format('MM');
		console.log(startMonth);
		console.log(endMonth);
		console.log('condition :', moment(startMonth).diff(moment(endMonth), 'months', true));
		if (moment(startMonth).diff(moment(endMonth), 'months', true) > 0) {
			this.currentDate = moment(this.displayDate).format('YYYY-MM-DD');
			this.calendarArray = this.getDaysArrayByMonth(this.currentDate);
		}
		this.menuCaller(moment(this.displayDate).format('YYYY/MM/DD'));

	}
	nextDate = () => {
		this.resetData(); this.resetMenu();
		this.displayDate = moment(this.displayDate).add(1, 'days').format('YYYY-MM-DD');
		this.selectedIndex = Number(moment(this.displayDate).format('DD'));
		//console.log(this.selectedIndex);		
		setTimeout(() => {
			this.dateSwiper?.nativeElement?.swiper?.slideTo(this.selectedIndex - 1, 1000);
		}, 1000);
		let startMonth = moment(this.currentDate).format('MM');
		let endMonth = moment(this.displayDate).format('MM');
		//console.log('condition :', moment(startMonth).diff(moment(endMonth), 'months', true));
		if (moment(startMonth).diff(moment(endMonth), 'months', true) < 0) {
			this.currentDate = moment(this.displayDate).format('YYYY-MM-DD');
			this.calendarArray = this.getDaysArrayByMonth(this.displayDate);
		}
		this.menuCaller(moment(this.displayDate).format('YYYY/MM/DD'));
	}
	dateSlideButtonClick = (selectedDate: Date) => {
		this.resetData(); this.resetMenu();
		this.displayDate = moment(selectedDate).format('YYYY-MM-DD');
		this.selectedIndex = Number(moment(this.displayDate).format('DD'));
		setTimeout(() => {
			this.dateSwiper?.nativeElement?.swiper?.slideTo(this.selectedIndex - 1, 1000);
		}, 1000);
		this.menuCaller(moment(this.displayDate).format('YYYY/MM/DD'));
	}
	getActiveDate = (dateGiven: Date) => {
		if (moment(dateGiven).isSame(moment(this.displayDate))) {
			return true;
		}
		return false;
	}
	disableDate = (dateGiven: Date) => {
		if (moment(dateGiven).isSameOrAfter(moment(this.today))) {
			return false;
		}
		return true;
	}
	getAcutalDisplayDate = (dateGiven: Date) => {
		moment.locale('en_US');
		if (this.settings.appLanguage == 'ar') {
			moment.locale('ar_SA');
		}
		return moment(dateGiven).format('DD MMMM YYYY');
	}
	getDaysArrayByMonth = (currentDate: any) => {
		var daysInMonth = moment(currentDate).daysInMonth();
		console.log('daysInMonth: ', daysInMonth);
		var arrDays = [];
		while (daysInMonth) {
			var current = moment(currentDate).date(daysInMonth);
			arrDays.push([moment(current).format('ddd'), moment(current).format('DD'), moment(current).format('YYYY-MM-DD')]);
			daysInMonth--;
		}
		//console.log(this.conditionDate);
		//console.log(this.mayActiveDates);
		//console.log(this.upcomingDates);
		return arrDays.reverse();
	}
	navigatePage = (page) => {
		this.ngZone.run(() => {
			let navigationExtras: NavigationExtras = {
				queryParams: {
					'historyRoute': 'onboarding',
					'redirectTo': 'signup',
				}
			}
			this.router.navigate([page], navigationExtras);
		});
	}
	toastMessage = async (msg) => {
		await this.toastCtrl.create({
			message: this.translate.instant(msg),
			duration: 4000,
			position: 'top',
			color: 'light'
		}).then(toastElem => toastElem.present());
	}
}
